import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthInfo } from 'types';
import ROUTES from 'constants/routes';
import { PhoneConfirmation } from 'containers/PhoneConfirmation/PhoneConfirmation';
import { PasswordUpdate } from 'containers/PasswordUpdate/PasswordUpdate';
import Panel from 'components/Panel/Panel';
import styles from './PhoneVerification.module.scss';

interface Props {
  confirmToken: string;
  setConfirmToken: (confirmToken: string) => void;
}

const { PRIVACY_POLICY_LINK, ORIGIN_URL } = process.env;

export const PhoneVerification: FC<Props> = ({ confirmToken, setConfirmToken }) => {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState<string>();

  const handlePhoneVerified = ({ token }: AuthInfo) => {
    setAccessToken(token);
  };

  const handlePasswordSet = () => {
    navigate(ROUTES.HOME);
  };

  if (accessToken) {
    return (
      <div className={styles.wrapper}>
        <Panel>
          <div className={styles.title}>Установите пароль</div>
          <PasswordUpdate accessToken={accessToken} onFinish={handlePasswordSet} />
        </Panel>
      </div>
    );
  }
  return (
    <Panel>
      <div className={styles.title}>Вход в личный кабинет</div>
      <PhoneConfirmation
        type={ROUTES.TOKEN_LOGIN}
        confirmToken={confirmToken}
        onFinish={handlePhoneVerified}
        onResend={setConfirmToken}
        checkbox={(
          <span className={styles.agreement}>
            Вводя код, я действую сознательно, соглашаюсь присоединиться к
            <a
              href={PRIVACY_POLICY_LINK}
              target="_blank"
              className={styles.agreementLink}
              rel="noreferrer"
            > публичному договору-оферте </a>
            по предоставлению услуг посредством дистанционных (цифровых) каналов
          </span>
        )}
      />
      <a href={ORIGIN_URL} className={styles.back}>← Вернуться</a>
    </Panel>
  );
};
